import { Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

type Props = {
  value: string
  readonly?: boolean
  onChange?: (e: any) => void
}

function getTokenFromTelegramEndpoint(endpoint: string) {
  const regexp = /^https:\/\/api.telegram.org\/bot(.+)\/sendMessage$/.exec(endpoint)

  if (!regexp || !regexp[1]) {
    return ''
  }

  return regexp[1]
}

export function MediumToken(props: Props) {
  const { value, readonly, onChange } = props
  const { t } = useTranslation()

  const extractedToken = getTokenFromTelegramEndpoint(value)

  return (
    <Form.Control
      value={readonly ? extractedToken : value}
      onChange={onChange}
      placeholder={t('notifications.medium.token-placeholder', 'API Token')}
      type="text"
      required={!readonly}
      readOnly={readonly}
    />
  )
}
